import React from 'react';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { FormMessageHOC } from 'common/HOCs';
import BaseButton from 'crm/_components/BaseButton';
import { createContactsExports } from 'crm/contacts/_redux';
import { staticStyles } from './style';

const SaveSelectionForm = ({ dispatch, handleSubmit, submitting, error }) => {
  const selectedContactsId = useSelector(state => state.crm.contacts.selectedContactsIds);
  const ibTreeData = useSelector(state => state.crm.contacts.ibTree);

  const getTradingDate = () => {
    const savedQuery = sessionStorage.getItem('fastFiltersQuery') || '';
    return queryString.parse(savedQuery).trading_date || null;
  };

  const getSymbolGroup = () => {
    const savedQuery = sessionStorage.getItem('fastFiltersQuery') || '';
    const parsed = queryString.parse(savedQuery);
    const raw = parsed.symbol_group;
    if (!raw) return [];
    return Array.isArray(raw) ? raw : [raw];
  };

  const getSearch = () => {
    const savedQuery = sessionStorage.getItem('fastFiltersQuery') || '';
    return queryString.parse(savedQuery).search || null;
  };

  // 区分 IB 节点和 User 节点
  const separateIbAndUserIds = (selectedIds, treeData) => {
    const ibIds = [];
    const userIds = [];

    // 递归遍历树
    const traverse = nodes => {
      if (!Array.isArray(nodes)) return;
      nodes.forEach(node => {
        if (node.node_type === 'ib') {
          // IB 节点：如果 ID 在选中列表中，加入 ibIds
          if (selectedIds.includes(node.id)) {
            ibIds.push(node.id);
          }
          // 递归处理子节点
          if (Array.isArray(node.children)) {
            traverse(node.children);
          }
        } else if (node.node_type === 'user') {
          // User 节点：如果 ID 在选中列表中，加入 userIds
          if (selectedIds.includes(node.id)) {
            userIds.push(node.id);
          }
        }
      });
    };

    traverse(treeData?.results || []);
    return { ibIds, userIds };
  };

  const submit = handleSubmit(() => {
    const { ibIds, userIds } = separateIbAndUserIds(selectedContactsId, ibTreeData);

    createContactsExports(
      {
        contactsId: userIds,
        contactsIbId: ibIds,
        tradingDate: getTradingDate(),
        symbolGroup: getSymbolGroup(),
        search: getSearch(),
      },
      dispatch
    );
  });
  return (
    <form className="SaveSelectionForm">
      <BaseButton type="submit" textId="justSave" onClick={submit} maxContent disabled={submitting} />
      {error && <span>{error}</span>}
      <style jsx global>
        {staticStyles}
      </style>
    </form>
  );
};

export default compose(
  FormMessageHOC,
  reduxForm({
    form: 'crm-reassign-manager',
    onSubmitSuccess: (result, dispatch, props) => {
      props.showFormSuccessMessage('crmReportsWereCreated');
      props.onRequestClose();
    },
  })
)(SaveSelectionForm);
